<template>
    <div>
        <sys-pop-over-config-base 
            :model="model" 
            :configs="configs" 
            :errors="errors"
            title="Configurações do Ponto"
            tool-tip="Configurações do Ponto"
        >
            <template v-slot:toolbar>
                <emc-button-icon 
                    icon="mdi-content-save" 
                    :text="error ? message : 'Salvar'" 
                    :loading="loadingSaving" 
                    :color="error ? 'error' : 'success'" 
                    @click="save()" 
                />
            </template>
        </sys-pop-over-config-base>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    name: "SysOccurrenceSheetSettingConfig",
    data: () => ({
        model: {},
        error: false,
        message: null,
        errors: {},
        loadingSaving: false,
        loading: false,
        configs: [
            { 
                type: 'boolean',   
                field: 'send_email_time_sheet_teacher',                            
                label: 'Enviar e-mail para professor',               
                textHelper: "Enviar e-mail para o professor quando houver alteração na folha de ponto",
                sm: 6
            },
            { 
                type: 'boolean',   
                field: 'send_email_time_sheet_user',                            
                label: 'Enviar e-mail para usuário',               
                textHelper: "Enviar e-mail para o usuário responsável quando houver alteração na folha de ponto",
                sm: 6
            },
            { 
                type: 'boolean',   
                field: 'save_card_mark',                            
                label: 'Salvar marcação de cartão',               
                textHelper: "Salvar marcação de cartão de ponto",
                sm: 6
            },
            { 
                type: 'boolean',   
                field: 'show_localization_proof',                            
                label: 'Mostrar prova de localização',               
                textHelper: "Exibir prova de localização nas marcações",
                sm: 6
            },
            { 
                type: 'boolean',   
                field: 'show_activity_item_separate',                            
                label: 'Mostrar atividades separadas',               
                textHelper: "Exibir atividades em itens separados",
                sm: 6
            },
            { 
                type: 'boolean',   
                field: 'in_person_only',                            
                label: 'Apenas presencial',               
                textHelper: "Permitir apenas marcações presenciais",
                sm: 6
            },
            { 
                type: 'boolean',   
                field: 'require_justification_on_edit',                            
                label: 'Exigir justificativa na edição',               
                textHelper: "Exigir justificativa ao editar marcações",
                sm: 6
            },
            { 
                type: 'boolean',   
                field: 'single_bond_aej',                            
                label: 'Vínculo único no AEJ',               
                textHelper: "Quando ativo, não gera registros Tipo 06 (múltiplos vínculos) no arquivo AEJ. Use para clientes que não possuem múltiplos vínculos docentes.",
                sm: 6
            },
            {
                type: 'boolean',
                field: 'on_demand_generation',
                label: 'Gerar folhas por demanda',
                textHelper: 'Quando ativo, gera/regera folhas de ponto ao acessar a tela do docente.',
                sm: 6
            },
            {
                type: 'boolean',
                field: 'allow_associate_work_times',
                label: 'Considerar períodos associados',
                textHelper: 'Quando ativo, a folha de ponto também considera aulas, atribuições e atividades dos períodos associados (mesmo ano e período).',
                sm: 6
            },
            {
                type: 'select',
                field: 'signature_type',
                label: 'Tipo de Assinatura',
                textHelper: 'Define como o professor assina o espelho de ponto: por e-mail (via B4) ou em tela, direto no SysClass.',
                items: [
                    { text: 'E-mail', value: 'email' },
                    { text: 'Em tela', value: 'embedded' }
                ],
                sm: 6
            },
            {
                type: 'text-field',
                field: 'electric_fence',
                label: 'Cerca eletrônica (metros)',
                textHelper: 'Distância máxima, em metros, entre a localização do professor e o endereço da empresa para efetuar o Checkin em "Ocorrências do Ponto". Vazio = não valida a localização.',
                clearable: true,
                sm: 6
            },
            {
                type: 'text-field',
                field: 'tolerance_minutes',
                label: 'Tolerância (minutos)',               
                textHelper: "Tolerância em minutos para marcações",
                clearable: true,
                sm: 6
            },
            { 
                type: 'text-field',   
                field: 'mark_limit_min',                            
                label: 'Limite mínimo de marcação',               
                textHelper: "Limite mínimo em minutos para antecipação de marcação",
                clearable: true,
                sm: 6
            },
            { 
                type: 'text-field',   
                field: 'mark_limit_max',                            
                label: 'Limite máximo de marcação',               
                textHelper: "Limite máximo em minutos para atraso de marcação",
                clearable: true,
                sm: 6
            },
        ]
    }),
    props: {
        companyId: {
            type: [Number, String],
            default: null
        }
    },
    mounted(){
        this.getData()
    },
    computed: {
        ...mapState('auth', ['acesso', 'header'])
    },
    watch: {
        companyId(){
            this.getData()
        }
    },
    methods: {
        ...mapActions('occurrenceSheetSetting', ['ActionIndex', 'ActionUpdate', 'ActionStore']),

        getData(){
            this.model = {}
            this.loading = true

            let params = {}
            
            if (this.companyId) {
                params.company_id = this.companyId
            }

            this.ActionIndex(params)
                .then((res) => {
                    if (res.data && res.data.data && res.data.data.length > 0) {
                        this.model = res.data.data[0]
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },

        save(){
            if (!this.model) {
                return
            }

            this.loadingSaving = true
            this.errors = {}
            this.error = false
            this.message = null

            // Adiciona educational_group_id do header do usuário se não existir
            if (!this.model.educational_group_id && this.header && this.header.educational_group_id) {
                this.model.educational_group_id = this.header.educational_group_id
            }

            const action = this.model.id ? this.ActionUpdate : this.ActionStore

            action(this.model)
                .then(() => {
                    this.message = 'Salvo com sucesso!'
                    this.getData()
                })
                .catch((error) => {
                    this.message = error.message || 'Erro ao salvar'
                    this.error = true
                    this.errors = error.errors || {}
                })
                .finally(() => {
                    this.loadingSaving = false
                })
        }
    }
}
</script>
